import { gsap} from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

const scrollTriggerSize = 1040;
// let progressImg;

function init() {

  const blockContainer = document.querySelector('.scroll-jacking-blocks__container')

  if (!blockContainer) {
    return;
  }

  const blockSection = blockContainer.parentNode
  const blocks = [...blockContainer.querySelectorAll('.scroll-jacking-blocks__block')]

  // const progressImgWrapper = document.createElement('div')
  // progressImgWrapper.classList.add('scroll-jacking-blocks__progress-image-wrapper')
  // blockSection.appendChild(progressImgWrapper)

  // jQuery.get('/wp-content/themes/BJGG/images/full-circle/full-circle-fixed.svg')
  //   .then((svgDoc) => {
  //     let svg = svgDoc.querySelector('svg')
  //     progressImg = svg;
  //     svg.classList.add('scroll-jacking-blocks__progress-image')
  //     progressImgWrapper.appendChild(svg)

  //     blocks.forEach((block) => {
  //       let clonedSvg = svg.cloneNode(true)
  //       block.querySelector('.scroll-jacking-blocks__block-content').appendChild(clonedSvg)
  //     })
  //   })

  const endDuration = () => {
    return `+=${(blocks.length * 1.5) * 100}% bottom`
  }

  let blockStatus = blocks.map(() => { return false })

  // let activeRotationPositions = [
  //   0,
  //   247,
  //   492,
  // ]

  const setActiveBlock = (activeIndex) => {

    if (blockStatus[activeIndex]) {
      return;
    }

    let positions = blocks.map((block, index) => {
      if (index > activeIndex) {
        blockStatus[index] = false
        return '100%';
      } else if (index < activeIndex) {
        blockStatus[index] = false
        return '-100%';
      } else {
        blockStatus[index] = true
        return '0';
      }
    })

    gsap.to(blocks[0], { y: positions[0], ease: "power4.inOut", overwrite: 'auto'  })
    gsap.to(blocks[1], { y: positions[1], ease: "power4.inOut", overwrite: 'auto'  })
    gsap.to(blocks[2], { y: positions[2], ease: "power4.inOut", overwrite: 'auto'  })

    // let segments = [...progressImg.querySelectorAll('.segment')]
    // gsap.to(segments, { opacity: .5, ease: "power4.inOut" })
    // gsap.to(segments[activeIndex], { opacity: 1, ease: "power4.inOut", overwrite: true })

    // gsap.to(progressImg, { rotation: activeRotationPositions[activeIndex], x: '-50%', y: '-50%', ease: "power4.inOut", overwrite: 'auto' })
  }

  const pinTimeline = gsap
    .timeline({
      id: 'tst',
      scrollTrigger: {
        trigger: blockContainer,
        // toggleActions: "play play reverse reverse",
        pin: true,   // pin the trigger element while active
        start: "top top", // when the top of the trigger hits the top of the viewport
        end: endDuration,
        scrub: true,
        onUpdate: function(scrollTrigger) {
          if (scrollTrigger.progress >= .6) {
            setActiveBlock(2)
          } else if (scrollTrigger.progress >= .3) {
            setActiveBlock(1)
          } else {
            setActiveBlock(0)
          }
        }
      },
    })

  // const progressTimeline = gsap
  //   .timeline({
  //     scrollTrigger: {
  //       trigger: progressImgWrapper,
  //       pinReparent: true,
  //       pin: true,
  //       start: "top top",
  //       end: endDuration,
  //       scrub: true,
  //       anticipatePin: 1,
  //     }
  //   })

    function resize() {
      if (window.innerWidth < scrollTriggerSize) {
        pinTimeline.scrollTrigger.disable()
        // progressTimeline.scrollTrigger.disable()

        blocks.forEach((block) => {
          block.style.transform = 'none'
        })

      } else {
        pinTimeline.scrollTrigger.enable()
        // progressTimeline.scrollTrigger.enable()
      }

      // Disable things if the window happens to be too short
      if (window.innerHeight < 850) {
        pinTimeline.scrollTrigger.disable()
        // progressTimeline.scrollTrigger.disable()

        blocks.forEach((block) => {
          block.style.transform = 'none'
          block.style.position = 'relative'
        })
      }
    }

    resize()
    window.addEventListener('resize', resize);
}

export default {
  init,
}
